module.exports = __webpack_public_path__ + "img/remove.c9a04780.png";